module.exports = __webpack_public_path__ + "img/slide-1.5204fd86.webp";